// Footer.js
import React from 'react';
import './Footer.css';
import { FaDiscord, FaYoutube } from 'react-icons/fa';
import { BsClipboard2CheckFill } from 'react-icons/bs';
import { MdOutlineVideoLibrary } from 'react-icons/md';
import paypalImg from './assets/paypal.png';
import visaImg from './assets/visa.png';
import mastercardImg from './assets/mastercard.png';
import aliplayImg from './assets/alipay.png';
import bitcoinImg from './assets/bitcoin.png';
import etherImg from './assets/ether.png';
import skinsImg from './assets/skins.png';
import giftcardsImg from './assets/giftcards.png';
import tetherImg from './assets/tether.png';
import webmoneyImg from './assets/webmoney.png';
import unionpayImg from './assets/unionpay.png';
import eagleLogo from './assets/eagle_logo.png';
import { useTranslation } from 'react-i18next';

const Footer = React.memo(() => {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      {/* Animated pulsating line */}
      <div className="footer-line"></div>
      <div className="footer__inner">
        {/* Logo ganz links und verlinkt */}
        <div className="footer__section footer__section--left">
          <a href="https://eaglescript.space/" className="footer__logo-link">
            <img 
              src={eagleLogo} 
              alt="EAGLE SCRIPT Logo - Best Rust No Recoil Script" 
              className="footer__logo" 
              loading="lazy"
            />
          </a>
        </div>

        {/* Second Column: Useful Links */}
        <div className="footer__section footer__section--left">
          <h3>{t('footer_useful_links')}</h3>
          <p>
            <a
              href="https://www.youtube.com/watch?v=t4YOfdqBrhs"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__link"
            >
              <MdOutlineVideoLibrary className="footer__icon" /> {t('footer_how_to_setup')}
            </a>
          </p>
          <p>
            <a
              href="#Tos"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__link"
            >
              <BsClipboard2CheckFill className="footer__icon" /> {t('footer_terms_of_service')}
            </a>
          </p>
        </div>

        {/* Third Column: Pay With */}
        <div className="footer__section footer__section--left">
          <h3>{t('footer_pay_with')}</h3>
          <div className="footer__grid">
            {[paypalImg, visaImg, mastercardImg, aliplayImg, bitcoinImg, etherImg, skinsImg, giftcardsImg, tetherImg, webmoneyImg, unionpayImg].map((src, i) => (
              <div key={i} className="footer__grid-item">
                <img src={src} alt={`Payment method ${i + 1} - Secure payment option`} loading="lazy" />
              </div>
            ))}
          </div>
        </div>

        {/* Fourth Column: Find Us On */}
        <div className="footer__section footer__section--left">
          <h3>{t('footer_find_us_on')}</h3>
          <div className="footer__contacts">
            <p>
              <a
                href="https://discord.com/invite/zEeq3jTzAR"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__link"
              >
                <FaDiscord className="footer__icon" /> {t('footer_discord')}
              </a>
            </p>
            <p>
              <a
                href="https://www.youtube.com/@rustnorecoil"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__link"
              >
                <FaYoutube className="footer__icon" /> {t('footer_youtube')}
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="footer__copyright">
        {t('footer_copyright')}
      </div>
    </footer>
  );
});

export default Footer;